import { clsx } from 'clsx'

export const BookingSummaryStepNumber = ({ current, number }: { current: boolean; number: number }) => (
  <svg
    aria-hidden="true"
    className={clsx('block size-6 shrink-0', current ? 'text-semantic-global-primary-default' : 'text-semantic-global-disabled-dark')}
    focusable="false"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="12" fill="currentColor" />
    <text x="12" y="12" dominantBaseline="central" textAnchor="middle" fill="white" fontFamily="inherit" fontSize="14" fontWeight="500">
      {number}
    </text>
  </svg>
)
